module.exports = __webpack_public_path__ + "img/umr_working.cd3c53a3.gif";